import type { ReactNode } from 'react';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface EmptyStateProps {
  icon: IconDefinition;
  title: string;
  description: string;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 'var(--space-16)',
      textAlign: 'center',
    }}>
      <div style={{
        width: '4rem',
        height: '4rem',
        borderRadius: 'var(--radius-xl)',
        background: 'var(--color-accent-subtle)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 'var(--space-6)',
      }}>
        <FontAwesomeIcon icon={icon} style={{ fontSize: 'var(--text-2xl)', color: 'var(--color-accent)' }} />
      </div>
      <h3 style={{ fontSize: 'var(--text-lg)', marginBottom: 'var(--space-2)' }}>{title}</h3>
      <p style={{ color: 'var(--color-text-secondary)', fontSize: 'var(--text-sm)', maxWidth: '360px', marginBottom: action ? 'var(--space-6)' : 0 }}>
        {description}
      </p>
      {action}
    </div>
  );
}
